'use strict';

import jQuery from 'jquery';
import RedPoint from './../../../vendor/redpoint';
import Core from './../../Core/Core';

/**
 * Pledge Form
 * Presidents Society and Visionary Society
 *
 * JavaScript functions for a pledge form page
 */
var PledgeForm = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {};

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create a reference to the fund selector
      privateNS.$fundSelector = privateNS.$container.find('.fund-selector');
      privateNS.$anonymousGift = privateNS.$container.find('.anonymous-gift')
      privateNS.$fundGroup = privateNS.$container.find('.fund-group');
      privateNS.$allFunds = privateNS.$fundGroup.find('input[type=checkbox]');
      privateNS.$inputText = privateNS.$fundGroup.find('textarea');
      privateNS.$fundLabels = privateNS.$fundGroup.find('label');

      // Create a reference to the submit button to enable and disable it.
      privateNS.$submitBtn = privateNS.$container.find('input[type=submit]');

      // Collect the form's redirect URL if available
      privateNS.$rpiRedirect = privateNS.$container.find('#rpiRedirect');

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Handles interactions with form subject selector
     *
     * @param {Event} event The triggering event
     */
    privateNS.onChangeFund = function onChangeFund(event) {

      // Prevent the default action of triggering event
      event.preventDefault();

      // Change the hidden inputs based on the value.
      if (this.value === 'True') {
        // disable the funds
        privateNS.$allFunds.prop('disabled', true);
        privateNS.$allFunds.prop('checked', false);
        privateNS.$fundLabels.addClass('disabled');
        privateNS.$inputText.attr('disabled', 'disabled');
      } else {
        // enable the funds
        privateNS.$allFunds.prop('disabled', false);
        privateNS.$inputText.attr('readonly', '');
        privateNS.$fundLabels.removeClass('disabled');
      }
    };

    /**
     * Handles interactions with form subject selector
     *
     * @param {Event} event The triggering event
     */
    privateNS.onChangeGift = function onChangeGift(event) {

      // Prevent the default action of triggering event
      event.preventDefault();

      // Change the hidden inputs based on the value.
      if (this.value === 'True') {
        // enable name recognition
        privateNS.$fundLabels.removeClass('disabled');
        privateNS.$inputText.attr('readonly', false);
      } else {
        privateNS.$inputText.attr('readonly', true);
        privateNS.$inputText.val('');
        privateNS.$fundLabels.addClass('disabled');
      }
    };

    /**
     * Attach the event handlers for the form
     */
    privateNS.attachHandlers = function() {

      // Attach the event handler for contact form selector change
      privateNS.$fundSelector.on(
        'change',
        privateNS.onChangeFund
      );

      // Attach the event handler for contact form selector change
      privateNS.$anonymousGift.on(
        'change',
        privateNS.onChangeGift
      );

      privateNS.$container.find('.ajax-form').on(
        'ajaxformsuccess',
        function() {

          // On a successful submission, replace the full submission wrapper
          // with the thank you message
          privateNS.$container.find('.pledge-form-wrapper').html(
            privateNS.$container.find('.pledge-form-submit-message')
          );
          
          // Finally scroll to the top of the contact message on mobile devices
          if ($.browser.mobile === true) {
            Core.utils.goToElement(privateNS.$container);
          }

          //Redirect to form's designated URL

          if (privateNS.$rpiRedirect) {
            setTimeout(
              function(){
                window.location = $rpiRedirect.val();
              },
              1000);
          }
        }
      );
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default PledgeForm